<template>
	<div class="row voffset3">
		<h4 class="text-center" v-text="progressBarLabel"></h4>
		<div class="progress">
			<progressBar :now="currentCompletion" type="success" striped label>
			</progressBar>
		</div>
	</div>
</template>

<script>
	import {progressbar as ProgressBar} from 'vue-strap'

	export default {
		components: {
			ProgressBar
		},
		computed: {
			currentCompletion: function()	{
				return  Math.round(this.$store.getters.completedAnswers * 100 / this.$store.getters.totalAnswersNumber);
			},
			progressBarLabel: function()	{
				let suffix = null;
				if (this.$store.state.user.currentStep == 'FIRST_STEP')	{
					suffix = "audit tour 1";
				}
				else if (this.$store.state.user.currentStep == 'CRITIC_STEP')	{
					suffix = "audit critique";
				}
				else if (this.$store.state.user.currentStep == 'SECOND_STEP')	{
					suffix = "audit tour 2";
				}
				else if (this.$store.state.user.currentStep == 'SATISFACTION_SURVEY')	{
					suffix = "enquête de satisfaction";
				}
				return "Avancement de l'" + suffix;
			}
		},	
		data: function()	{
			return {
			};
		}
	}
</script>